import { Row } from 'antd';
import { mediaQuery } from 'modules/utils';
import styled from 'styled-components';

export const StyledDescriptionRow = styled(Row)`
  margin-top: 1.8rem;
  margin-bottom: 3.2rem;
`;

export const StyledBackButtonRow = styled(Row)`
  height: 6rem;
`;

export const ThirdWidthRow = styled(Row)`
  width: 100%;
  margin-bottom: 10rem;

  ${mediaQuery('md')} {
    width: 30%;
    min-width: 22.5rem;
  }
`;
